(function () {
  "use strict";

  var GLOBAL_POLL_INTERVAL_MS = 50;
  var GLOBAL_LOAD_TIMEOUT_MS = 5000;
  var GLOBAL_MAX_ATTEMPTS = GLOBAL_LOAD_TIMEOUT_MS / GLOBAL_POLL_INTERVAL_MS;

  var assetsPromise = null;

  function getConfig() {
    var script = document.querySelector("[data-ff-swiper-assets]");
    if (!script) return null;

    return {
      css: script.getAttribute("data-swiper-bundle-css"),
      js: script.getAttribute("data-swiper-bundle-js"),
      carousel: script.getAttribute("data-carousel-js"),
    };
  }

  function loadStylesheet(href) {
    if (!href) return Promise.resolve();
    if (document.querySelector('link[rel="stylesheet"][href="' + href + '"]')) {
      return Promise.resolve();
    }

    return new Promise(function (resolve, reject) {
      var link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      link.onload = resolve;
      link.onerror = function () {
        link.remove();
        reject(new Error("Failed to load Swiper CSS"));
      };
      document.head.appendChild(link);
    });
  }

  function waitForGlobal(name) {
    return new Promise(function (resolve, reject) {
      if (window[name] !== undefined && window[name] !== null) {
        resolve();
        return;
      }

      var attempts = 0;
      var timer = setInterval(function () {
        attempts += 1;
        if (window[name] !== undefined && window[name] !== null) {
          clearInterval(timer);
          resolve();
          return;
        }
        if (attempts >= GLOBAL_MAX_ATTEMPTS) {
          clearInterval(timer);
          reject(new Error(name + " did not load"));
        }
      }, GLOBAL_POLL_INTERVAL_MS);
    });
  }

  function loadScript(src, globalName) {
    if (!src) return Promise.resolve();
    if (globalName && window[globalName] !== undefined) return Promise.resolve();

    var existing = document.querySelector('script[src="' + src + '"]');
    if (existing) {
      return globalName ? waitForGlobal(globalName) : Promise.resolve();
    }

    return new Promise(function (resolve, reject) {
      var script = document.createElement("script");
      script.src = src;
      script.async = false;
      script.onload = function () {
        if (globalName) {
          waitForGlobal(globalName).then(resolve).catch(reject);
          return;
        }
        resolve();
      };
      script.onerror = function () {
        script.remove();
        reject(new Error("Failed to load script: " + src));
      };
      document.head.appendChild(script);
    });
  }

  function loadAssets(config) {
    if (!config) return Promise.resolve();
    if (window.__ffSwiperAssetsLoaded) {
      return assetsPromise || Promise.resolve();
    }

    if (!assetsPromise) {
      assetsPromise = loadStylesheet(config.css)
        .then(function () {
          return loadScript(config.js, "Swiper");
        })
        .then(function () {
          return loadScript(config.carousel);
        })
        .then(function () {
          window.__ffSwiperAssetsLoaded = true;
        })
        .catch(function (error) {
          assetsPromise = null;
          window.__ffSwiperAssetsLoaded = false;
          throw error;
        });
    }

    return assetsPromise;
  }

  window.HaloSwiperLoader = {
    ensure: function () {
      return loadAssets(getConfig()).then(function () {
        return window.Swiper;
      });
    },
  };

  function boot(root) {
    var scope = root || document;
    if (!scope.querySelector(".swiper")) return;
    if (!document.querySelector("[data-ff-swiper-assets]")) return;

    var config = getConfig();
    loadAssets(config)
      .then(function () {
        if (typeof window.FfInitSwiperCarousels === "function") {
          window.FfInitSwiperCarousels(root);
        }
      })
      .catch(function (error) {
        console.error("[FfSwiperAssets]", error);
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (event) {
    boot(event.target);
  });
})();
